import { render, staticRenderFns } from "./Google.vue?vue&type=template&id=0b4faa4c"
import script from "./Google.vue?vue&type=script&lang=ts"
export * from "./Google.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports